// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"q0-z"};